// Phase 2 §5: useProjectionMode hook
// Manages Legal vs Scenario mode state with sessionStorage persistence

import { useState, useEffect, useCallback } from 'react';

type CapTableMode = 'LEGAL' | 'SCENARIO';

const STORAGE_KEY = 'capledger_projection_mode';

export function useProjectionMode() {
  const [mode, setModeState] = useState<CapTableMode>(() => {
    // Initialize from sessionStorage or default to LEGAL
    if (typeof window !== 'undefined') {
      const stored = sessionStorage.getItem(STORAGE_KEY);
      return (stored === 'SCENARIO' ? 'SCENARIO' : 'LEGAL') as CapTableMode;
    }
    return 'LEGAL';
  });

  const setMode = useCallback((newMode: CapTableMode) => {
    setModeState(newMode);
    if (typeof window !== 'undefined') {
      sessionStorage.setItem(STORAGE_KEY, newMode);
    }
  }, []);

  const toggleMode = useCallback(() => {
    setMode(mode === 'LEGAL' ? 'SCENARIO' : 'LEGAL');
  }, [mode, setMode]);

  const isScenarioMode = mode === 'SCENARIO';
  const isLegalMode = mode === 'LEGAL';

  // Get state_type filter for Supabase queries
  const getStateTypeFilter = useCallback(() => {
    return mode === 'LEGAL' ? 'LEGAL' : ['PROJECTION', 'SCENARIO'];
  }, [mode]);

  return {
    mode,
    setMode,
    toggleMode,
    isScenarioMode,
    isLegalMode,
    getStateTypeFilter,
  };
}
